import {computed}  from 'mobx';
import {auth} from 'shared/core';
import CalendarEvent from './CalendarEvent';

class TimeOffRequestEvent extends CalendarEvent {
  @computed get backgroundColor() {
    return this.extendedProps.status === 'approved' ? '#1776F5' : '#FFFFFF';
  }

  @computed get textColor() {
    return this.extendedProps.status === 'approved' ? '#FFFFFF' : '#1776F5';
  }

  @computed get borderColor() {
    return '#1776F5';
  }

  @computed get canViewDetails() {
    return auth.hasAccess('::MANAGE_TIME_OFF');
  }
}

export default TimeOffRequestEvent;
